import { frontendURL } from 'dashboard/helper/URLHelper';
import ActiveMessagesIndex from './ActiveMessagesIndex.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/active_messages'),
      name: 'active_messages_index',
      component: ActiveMessagesIndex,
      meta: {
        featureFlag: FEATURE_FLAGS.CAMPAIGNS,
        permissions: ['administrator', 'campaign_manage'],
        module: 'campaigns',
      },
    },
  ],
};
